<template>
  <div class="home">
    <swiper :options="swiperOption" ref="mySwiper" class="m-swiper">
      <swiper-slide v-for="item in bannerList" :key="'banner' + item">
        <img :src="item" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div
        class="swiper-button-prev swiper-button-white"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-button-white"
        slot="button-next"
      ></div> -->
    </swiper>
    <TeenWelcomeBar />
    <div class="home-container" style="margin-bottom: 40px">
      <h3 class="tit">直播推荐</h3>
      <div class="live-content">
        <div
          class="live-div"
          v-for="(item, index) in liveList"
          :key="index + 'live'"
          @mouseover="showPlay = item"
          @mouseout="showPlay = ''"
          @click="goLive(item)"
        >
          <div class="img">
            <img :src="item.cover" />
            <div class="over-div" v-show="showPlay == item">
              <img src="../assets/img/play.png" />
            </div>
          </div>
          <div class="live-text">
            <div class="name">{{ item.title }}</div>
            <div class="num">
              <img src="../assets/img/people.png" />
              {{ item.num }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-container">
      <h3 class="tit">娱乐焦点</h3>
      <p
        v-for="item in entertainmentArticles"
        :key="`article-${item.id}`"
        class="list entertainment-list"
      >
        <a @click="goDetail(item.id)">· {{ item.title }}</a>
        <span class="time">{{ item.date }}</span>
      </p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
// .home {
//   padding-top: 30px;
// }
.home-container {
  text-align: left;
  max-width: 1000px;
  width: 100%;
  margin: 40px auto 80px;
  padding: 0 16px;
  box-sizing: border-box;
}

.m-swiper {
  width: 100%;

  // height: 600px;
  img {
    width: 100%;
  }
}

// .swiper-pagination {
//   bottom: -100px;
// }
.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  text-align: center;
  color: #000;
  opacity: 1;
  background: rgba(255, 255, 255, 0.2);
}

.swiper-pagination-bullet-active {
  color: #fff;
  background: #ffffff !important;
}

.live-content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
  margin: auto;

  .live-div {
    width: calc(19% - 10px);
    min-width: 140px;
    height: auto;
    background: #ffffff;
    border-radius: 4px;
    margin-right: 15px;
    position: relative;
    cursor: pointer;
    margin-bottom: 15px;

    .img {
      width: 100%;
      padding-top: 56.25%;
      position: relative;
      border-radius: 3px 3px 0px 0px;
      overflow: hidden;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .live-text {
      display: flex;
      align-items: center;
      height: 40px;
      justify-content: space-between;
      padding: 12px;
      box-sizing: border-box;

      .name {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        line-height: 18px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .num {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        flex-shrink: 0;
        margin-left: 4px;

        img {
          width: 12px;
          height: 12px;
        }
      }
    }

    .over-div {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 3px 3px 0px 0px;

      img {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

@media (max-width: 768px) {
  .live-content .live-div {
    width: calc(50% - 8px);
    min-width: unset;
    margin-right: 0;

    &:nth-child(odd) {
      margin-right: 16px;
    }
  }
}
</style>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import LiveList from '../constant/live'
import entertainmentArticles from '../constant/entertainment'
import TeenWelcomeBar from '../components/TeenWelcomeBar'
const banner3 = require('../assets/img/直播banner03.png')
const banner4 = require('../assets/img/直播banner04.png')
const banner5 = require('../assets/img/直播banner05.png')
const banner01 = require('../assets/img/banner01.png')

export default {
  name: 'Home',
  components: {
    swiper,
    swiperSlide,
    TeenWelcomeBar,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      bannerList: [
        banner01,
        banner3,
        banner4,
        banner5,
        'http://static.yunxi.tv/yunxi/web/music/banner/4.jpg',
        'http://static.yunxi.tv/yunxi/web/music/banner/5.jpg',
      ],
      liveList: [],
      entertainmentArticles,
      showPlay: '',
    }
  },
  created() {
    this.initHomeLiveListForAccount()
    if (localStorage.getItem('teenagerMode') === 'true') {
      this.$Message.info('青少年模式已开启，今日还可观看' + this.getRemainingTime())
    }
    if (this.$root && this.$root.$on) {
      this.$root.$on('account-changed', this.initHomeLiveListForAccount)
    }
  },
  beforeDestroy() {
    if (this.$root && this.$root.$off) {
      this.$root.$off('account-changed', this.initHomeLiveListForAccount)
    }
  },
  methods: {
    isTeenTimeExceeded() {
      if (localStorage.getItem('teenagerMode') !== 'true') return false
      const used = Number(localStorage.getItem('viewDuration')) || 0
      const remaining = 40 * 60 - used
      return remaining <= 0
    },
    getRemainingTime() {
      const used = Number(localStorage.getItem('viewDuration')) || 0
      const remaining = Math.max(40 * 60 - used, 0)
      const m = Math.floor(remaining / 60)
      const s = remaining % 60
      return m > 0 ? `${m}分钟${s > 0 ? s + '秒' : ''}` : `${s}秒`
    },
    initHomeLiveListForAccount() {
      const list = this.getRandomLiveList()
      // 避免直接污染常量数据
      this.liveList = list.map((x) => ({ ...x, num: parseInt(Math.random() * 5000, 10) }))
    },
    isExternalLivePageUrl(url) {
      if (!url || typeof url !== 'string') return false
      return /^https?:\/\//i.test(url) && url.indexOf('/page/') !== -1
    },
    getRandomLiveList() {
      const isTeenagerMode = localStorage.getItem('teenagerMode') === 'true'
      const base = LiveList.filter((item) => item && item.cover)

      // 首页“直播推荐”：非青少年模式优先推荐演艺；青少年模式则推荐非演艺，避免空列表
      const preferred = isTeenagerMode
        ? base.filter((item) => item.type !== '演艺')
        : base.filter((item) => item.type === '演艺')
      const fallback = base

      const performanceList = (preferred.length ? preferred : fallback).filter((item) => item && item.cover)

      // “泡沫”在演艺类型里固定第一位，其余再随机
      const pinnedId = 51
      const pinned = performanceList.find((x) => x && x.id === pinnedId)
      const rest = performanceList.filter((x) => !(x && x.id === pinnedId))

      // Fisher–Yates shuffle（避免 sort(Math.random) 带来的偏差）
      const shuffledList = [...rest]
      for (let i = shuffledList.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[shuffledList[i], shuffledList[j]] = [shuffledList[j], shuffledList[i]]
      }

      const result = pinned ? [pinned, ...shuffledList] : shuffledList
      return result.slice(0, 5)
    },
    goDetail(index) {
      this.$router.push(`/doc${index}`)
    },
    appendTokenToExternalLiveUrl(url) {
      const token = localStorage.getItem('token') || ''
      const teenagerMode = localStorage.getItem('teenagerMode') === 'true'
      const sep = url.indexOf('?') === -1 ? '?' : '&'
      return `${url}${sep}token=${token}&teenagerMode=${teenagerMode}`
    },
    goLive(item) {
      if (!localStorage.getItem('token')) {
        this.$Message.warning('请先登录')
        this.$root.$emit('show-login')
        return
      }
      if (this.isTeenTimeExceeded()) {
        this.$root.$emit('teen-time-exceeded')
        return
      }
      if (this.isExternalLivePageUrl(item && item.url)) {
        window.location.href = this.appendTokenToExternalLiveUrl(item.url)
        return
      }
      sessionStorage.setItem('detail', JSON.stringify(item))
      sessionStorage.setItem('liveEnterFromClickAt', String(Date.now()))
      this.$router.push('/detail')
    },
  },
}
</script>
